import { useState, useEffect } from 'react';

const OfflineBanner = () => {
  const [isOnline, setIsOnline]   = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const [showBack, setShowBack]   = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowBack(true);
        setTimeout(() => setShowBack(false), 4000);
      }
    };
    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };
    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !showBack) return null;

  return (
    <div style={{
      position: 'fixed', top: 64, left: 0, right: 0, zIndex: 9998,
      background: isOnline ? '#086F3C' : '#231F20',
      color: '#fff',
      padding: '8px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
      fontSize: '0.82rem', fontWeight: 500,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      animation: 'bannerSlide 0.3s ease',
    }}>
      {isOnline ? (
        <>
          <span style={{ fontSize: '1rem' }}>✅</span>
          <span>Back online — your data is syncing</span>
        </>
      ) : (
        <>
          <span style={{ fontSize: '1rem' }}>📵</span>
          <span>You're offline — some features may be unavailable</span>
          <div style={{
            width: 8, height: 8, borderRadius: '50%', background: '#F2652C',
            animation: 'pulse 1.5s infinite', marginLeft: 4,
          }} />
        </>
      )}
      <style>{`
        @keyframes bannerSlide {
          from { transform: translateY(-40px); opacity: 0; }
          to   { transform: translateY(0);     opacity: 1; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.4; transform: scale(1.4); }
        }
      `}</style>
    </div>
  );
};

export default OfflineBanner;
